import * as React from 'react';
import { classNames, Styleable } from '../utils/styles';

export enum BoxStyle {
  Default = 'bg-transparent',
  Filled = 'bg-near-white',
  Padded = 'pa2 pa4-ns',
}

export interface BoxProps extends Styleable {
  children: any;
}

export const Box = (props: BoxProps) => (
  <div className={props.className}>
    {props.children}
  </div>
);

export default Box;
